// Copyright 2026, University of Maryland, All Rights Reserved
import type { FC } from 'react'

import { MarkdownViewer } from '@/components/ui'

import type { KbSchema } from '../types'

interface SchemaFieldsViewProps {
  schema: KbSchema
  fields: Record<string, string>
}

/**
 * Render a KB item using its schema. Each field gets a small label header
 * and its value rendered as markdown (markdown/textarea fields) or plain
 * text (text fields).
 */
export const SchemaFieldsView: FC<SchemaFieldsViewProps> = ({ schema, fields }) => (
  <dl className="space-y-3">
    {schema.fields.map(field => {
      const value = fields[field.key]
      if (!value || !value.trim()) return null
      return (
        <div key={field.key} className="space-y-1">
          <dt className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
            {field.label}
          </dt>
          <dd className="text-sm">
            {field.type === 'text' ? (
              <span>{value}</span>
            ) : (
              <MarkdownViewer content={value} />
            )}
          </dd>
        </div>
      )
    })}
  </dl>
)
